export const THIRDMASK = 0x4000
export const UPPERMASK = 0x1000

export const EAJL_2_1 = 0x100
export const EAJL_2_2 = 0x200
export const EAJL_2 = 0x300

export const IS_MALE = 0x400
// export const IS_MALE = 0x0

export const EAJL_UPPER = 0x1000
export const EAJL_BABY = 0x2000
export const EAJL_THIRD = 0x4000
export const EAJL_FOURTH = 0x8000 //good value?

//base
export const NOVICE = 0x0
export const SWORDMAN = 0x1
export const MAGE = 0x2
export const ARCHER = 0x3
export const ACOLYTE = 0x4
export const MERCHANT = 0x5
export const THIEF = 0x6
export const TAEKWON = 0x7
export const GUNSLINGER = 0x9
export const NINJA = 0x0a
export const GANGSI = 0x0d //?
export const SUMMONER = 0x10
//2_1
export const KNIGHT = SWORDMAN | EAJL_2_1
export const WIZARD = MAGE | EAJL_2_1
export const HUNTER = ARCHER | EAJL_2_1
export const PRIEST = ACOLYTE | EAJL_2_1
export const BLACKSMITH = MERCHANT | EAJL_2_1
export const ASSASSIN = THIEF | EAJL_2_1
export const STAR_GLADIATOR = TAEKWON | EAJL_2_1
export const STARGLADIATOR = TAEKWON | EAJL_2_1
export const REBELLION = GUNSLINGER | EAJL_2_1
// export const KAGEROUOBORO = NINJA | EAJL_2_1
export const KAGEROU = NINJA | EAJL_2_1 | IS_MALE
export const OBORO = NINJA | EAJL_2_1
export const DEATH_KNIGHT = GANGSI | EAJL_2_1 //??
export const DEATHKNIGHT = GANGSI | EAJL_2_1
//2_2
export const CRUSADER = SWORDMAN | EAJL_2_2
export const SAGE = MAGE | EAJL_2_2
// export const BARDDANCER = ARCHER | EAJL_2_2
export const BARD = ARCHER | EAJL_2_2 | IS_MALE
export const DANCER = ARCHER | EAJL_2_2
export const MONK = ACOLYTE | EAJL_2_2
export const ALCHEMIST = MERCHANT | EAJL_2_2
export const ROGUE = THIEF | EAJL_2_2
export const SOUL_LINKER = TAEKWON | EAJL_2_2
export const DARK_COLLECTOR = GANGSI | EAJL_2_2 //??
export const DARKCOLLECTOR = GANGSI | EAJL_2_2

//Advanced
//base
export const NOVICE_HIGH = NOVICE | EAJL_UPPER
export const SWORDMAN_HIGH = SWORDMAN | EAJL_UPPER
export const MAGE_HIGH = MAGE | EAJL_UPPER
export const ARCHER_HIGH = ARCHER | EAJL_UPPER
export const ACOLYTE_HIGH = ACOLYTE | EAJL_UPPER
export const MERCHANT_HIGH = MERCHANT | EAJL_UPPER
export const THIEF_HIGH = THIEF | EAJL_UPPER
//2_1
export const LORD_KNIGHT = SWORDMAN | EAJL_2_1 | EAJL_UPPER
export const HIGH_WIZARD = MAGE | EAJL_2_1 | EAJL_UPPER
export const SNIPER = ARCHER | EAJL_2_1 | EAJL_UPPER
export const HIGH_PRIEST = ACOLYTE | EAJL_2_1 | EAJL_UPPER
export const WHITESMITH = MERCHANT | EAJL_2_1 | EAJL_UPPER
export const ASSASSIN_CROSS = THIEF | EAJL_2_1 | EAJL_UPPER
//2_2
export const PALADIN = SWORDMAN | EAJL_2_2 | EAJL_UPPER
export const PROFESSOR = MAGE | EAJL_2_2 | EAJL_UPPER
// export const CLOWNGYPSY = ARCHER | EAJL_2_2 | EAJL_UPPER
export const CLOWN = ARCHER | EAJL_2_2 | EAJL_UPPER | IS_MALE
export const GYPSY = ARCHER | EAJL_2_2 | EAJL_UPPER
export const CHAMPION = ACOLYTE | EAJL_2_2 | EAJL_UPPER
export const CREATOR = MERCHANT | EAJL_2_2 | EAJL_UPPER
export const STALKER = THIEF | EAJL_2_2 | EAJL_UPPER

//Baby
export const BABY = NOVICE | EAJL_BABY
export const BABY_SWORDMAN = SWORDMAN | EAJL_BABY
export const BABY_MAGE = MAGE | EAJL_BABY
export const BABY_ARCHER = ARCHER | EAJL_BABY
export const BABY_ACOLYTE = ACOLYTE | EAJL_BABY
export const BABY_MERCHANT = MERCHANT | EAJL_BABY
export const BABY_THIEF = THIEF | EAJL_BABY
export const BABY_TAEKWON = TAEKWON | EAJL_BABY
export const BABY_GUNSLINGER = GUNSLINGER | EAJL_BABY
export const BABY_NINJA = NINJA | EAJL_BABY
export const BABY_SUMMONER = SUMMONER | EAJL_BABY
//2_1
export const BABY_KNIGHT = SWORDMAN | EAJL_2_1 | EAJL_BABY
export const BABY_WIZARD = MAGE | EAJL_2_1 | EAJL_BABY
export const BABY_HUNTER = ARCHER | EAJL_2_1 | EAJL_BABY
export const BABY_PRIEST = ACOLYTE | EAJL_2_1 | EAJL_BABY
export const BABY_BLACKSMITH = MERCHANT | EAJL_2_1 | EAJL_BABY
export const BABY_ASSASSIN = THIEF | EAJL_2_1 | EAJL_BABY
export const BABY_STAR_GLADIATOR = TAEKWON | EAJL_2_1 | EAJL_BABY
export const BABY_REBELLION = GUNSLINGER | EAJL_2_1 | EAJL_BABY
// export const BABY_KAGEROUOBORO = NINJA | EAJL_2_1 | EAJL_BABY
export const BABY_KAGEROU = NINJA | EAJL_2_1 | EAJL_BABY | IS_MALE
export const BABY_OBORO = NINJA | EAJL_2_1 | EAJL_BABY | IS_MALE
//2_2
export const BABY_CRUSADER = SWORDMAN | EAJL_2_2 | EAJL_BABY
export const BABY_SAGE = MAGE | EAJL_2_2 | EAJL_BABY
// export const BABY_BARDDANCER = ARCHER | EAJL_2_2 | EAJL_BABY
export const BABY_BARD = ARCHER | EAJL_2_2 | EAJL_BABY | IS_MALE
export const BABY_DANCER = ARCHER | EAJL_2_2 | EAJL_BABY
export const BABY_MONK = ACOLYTE | EAJL_2_2 | EAJL_BABY
export const BABY_ALCHEMIST = MERCHANT | EAJL_2_2 | EAJL_BABY
export const BABY_ROGUE = THIEF | EAJL_2_2 | EAJL_BABY
export const BABY_SOUL_LINKER = TAEKWON | EAJL_2_2 | EAJL_BABY

//3rd
//2_1
export const RUNE_KNIGHT = SWORDMAN | EAJL_2_1 | EAJL_THIRD
export const WARLOCK = MAGE | EAJL_2_1 | EAJL_THIRD
export const RANGER = ARCHER | EAJL_2_1 | EAJL_THIRD
export const ARCH_BISHOP = ACOLYTE | EAJL_2_1 | EAJL_THIRD
export const MECHANIC = MERCHANT | EAJL_2_1 | EAJL_THIRD
export const GUILLOTINE_CROSS = THIEF | EAJL_2_1 | EAJL_THIRD
export const STAR_EMPEROR = TAEKWON | EAJL_2_1 | EAJL_THIRD
//2_2
export const ROYAL_GUARD = SWORDMAN | EAJL_2_2 | EAJL_THIRD
export const SORCERER = MAGE | EAJL_2_2 | EAJL_THIRD
// export const MINSTRELWANDERER = ARCHER | EAJL_2_2 | EAJL_THIRD
export const MINSTREL = ARCHER | EAJL_2_2 | EAJL_THIRD | IS_MALE
export const WANDERER = ARCHER | EAJL_2_2 | EAJL_THIRD
export const SURA = ACOLYTE | EAJL_2_2 | EAJL_THIRD
export const GENETIC = MERCHANT | EAJL_2_2 | EAJL_THIRD
export const SHADOW_CHASER = THIEF | EAJL_2_2 | EAJL_THIRD
export const SOUL_REAPER = TAEKWON | EAJL_2_2 | EAJL_THIRD

//Advanced 3rd
//2_1
export const RUNE_KNIGHT_T = SWORDMAN | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
export const WARLOCK_T = MAGE | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
export const RANGER_T = ARCHER | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
export const ARCH_BISHOP_T = ACOLYTE | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
export const MECHANIC_T = MERCHANT | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
export const GUILLOTINE_CROSS_T = THIEF | EAJL_2_1 | EAJL_THIRD | EAJL_UPPER
//2_2
export const ROYAL_GUARD_T = SWORDMAN | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
export const SORCERER_T = MAGE | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
// export const MINSTRELWANDERER_T = ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
export const MINSTREL_T = ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER | IS_MALE
export const WANDERER_T = ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
export const SURA_T = ACOLYTE | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
export const GENETIC_T = MERCHANT | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER
export const SHADOW_CHASER_T = THIEF | EAJL_2_2 | EAJL_THIRD | EAJL_UPPER

//Baby 3rd
//2_1
export const BABY_RUNE_KNIGHT = SWORDMAN | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_WARLOCK = MAGE | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_RANGER = ARCHER | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_ARCH_BISHOP = ACOLYTE | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_MECHANIC = MERCHANT | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_GUILLOTINE_CROSS = THIEF | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
export const BABY_STAR_EMPEROR = TAEKWON | EAJL_2_1 | EAJL_THIRD | EAJL_BABY
//2_2
export const BABY_ROYAL_GUARD = SWORDMAN | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_SORCERER = MAGE | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
// export const BABY_MINSTRELWANDERER = ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_MINSTREL =
	ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_BABY | IS_MALE
export const BABY_WANDERER = ARCHER | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_SURA = ACOLYTE | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_GENETIC = MERCHANT | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_SHADOW_CHASER = THIEF | EAJL_2_2 | EAJL_THIRD | EAJL_BABY
export const BABY_SOUL_REAPER = TAEKWON | EAJL_2_2 | EAJL_THIRD | EAJL_BABY

//SN
export const SUPER_NOVICE = NOVICE | EAJL_2_1
export const SUPERNOVICE = NOVICE | EAJL_2_1
export const SUPER_BABY = NOVICE | EAJL_2_1 | EAJL_BABY
export const SUPER_NOVICE_E = NOVICE | EAJL_2_1 | EAJL_THIRD
export const SUPER_BABY_E = NOVICE | EAJL_2_1 | EAJL_THIRD | EAJL_BABY

export function getClassName(classID, source) {
	switch (classID) {
		//Novice And 1-1 Jobs
		case NOVICE:
			return 'NOVICE'
		case SWORDMAN:
			return 'SWORDMAN'
		case MAGE:
			return 'MAGE'
		case ARCHER:
			return 'ARCHER'
		case ACOLYTE:
			return 'ACOLYTE'
		case MERCHANT:
			return 'MERCHANT'
		case THIEF:
			return 'THIEF'
		case TAEKWON:
			return 'TAEKWON'
		// case WEDDING:               return WEDDING;
		case GUNSLINGER:
			return 'GUNSLINGER'
		case NINJA:
			return 'NINJA'
		// case XMAS:                  return XMAS;
		// case SUMMER:                return SUMMER;
		// case HANBOK:                return HANBOK;
		// case GANGSI:                return GANGSI;
		// case OKTOBERFEST:           return OKTOBERFEST;
		// case SUMMER2:               return SUMMER2;
		//2-1 Jobs
		case SUPER_NOVICE:
			return 'SUPER_NOVICE'
		case KNIGHT:
			return 'KNIGHT'
		case WIZARD:
			return 'WIZARD'
		case HUNTER:
			return 'HUNTER'
		case PRIEST:
			return 'PRIEST'
		case BLACKSMITH:
			return 'BLACKSMITH'
		case ASSASSIN:
			return 'ASSASSIN'
		case STAR_GLADIATOR:
			return 'STAR_GLADIATOR'
		case KAGEROU:
			return 'KAGEROU'
		case OBORO:
			return 'OBORO'
		case REBELLION:
			return 'REBELLION'
		// case DEATH_KNIGHT:          return DEATH_KNIGHT;
		//2-2 Jobs
		case CRUSADER:
			return 'CRUSADER'
		case SAGE:
			return 'SAGE'
		case BARD:
			return 'BARD'
		case DANCER:
			return 'DANCER'
		case MONK:
			return 'MONK'
		case ALCHEMIST:
			return 'ALCHEMIST'
		case ROGUE:
			return 'ROGUE'
		case SOUL_LINKER:
			return 'SOUL_LINKER'
		// case DARK_COLLECTOR:        return DARK_COLLECTOR;
		//Trans Novice And Trans 1-1 Jobs
		case NOVICE_HIGH:
			return 'NOVICE_HIGH'
		case SWORDMAN_HIGH:
			return 'SWORDMAN_HIGH'
		case MAGE_HIGH:
			return 'MAGE_HIGH'
		case ARCHER_HIGH:
			return 'ARCHER_HIGH'
		case ACOLYTE_HIGH:
			return 'ACOLYTE_HIGH'
		case MERCHANT_HIGH:
			return 'MERCHANT_HIGH'
		case THIEF_HIGH:
			return 'THIEF_HIGH'
		//Trans 2-1 Jobs
		case LORD_KNIGHT:
			return 'LORD_KNIGHT'
		case HIGH_WIZARD:
			return 'HIGH_WIZARD'
		case SNIPER:
			return 'SNIPER'
		case HIGH_PRIEST:
			return 'HIGH_PRIEST'
		case WHITESMITH:
			return 'WHITESMITH'
		case ASSASSIN_CROSS:
			return 'ASSASSIN_CROSS'
		//Trans 2-2 Jobs
		case PALADIN:
			return 'PALADIN'
		case PROFESSOR:
			return 'PROFESSOR'
		case CLOWN:
			return 'CLOWN'
		case GYPSY:
			return 'GYPSY'
		case CHAMPION:
			return 'CHAMPION'
		case CREATOR:
			return 'CREATOR'
		case STALKER:
			return 'STALKER'
		//Baby Novice And Baby 1-1 Jobs
		case BABY:
			return 'Novice'
		case BABY_SWORDMAN:
			return 'BABY_SWORDMAN'
		case BABY_MAGE:
			return 'BABY_MAGE'
		case BABY_ARCHER:
			return 'BABY_ARCHER'
		case BABY_ACOLYTE:
			return 'BABY_ACOLYTE'
		case BABY_MERCHANT:
			return 'BABY_MERCHANT'
		case BABY_THIEF:
			return 'BABY_THIEF'
		case BABY_TAEKWON:
			return 'BABY_TAEKWON'
		case BABY_GUNSLINGER:
			return 'BABY_GUNSLINGER'
		case BABY_NINJA:
			return 'BABY_NINJA'
		case BABY_SUMMONER:
			return 'BABY_SUMMONER'
		//Baby 2-1 Jobs
		case SUPER_BABY:
			return 'SUPER_BABY'
		case BABY_KNIGHT:
			return 'BABY_KNIGHT'
		case BABY_WIZARD:
			return 'BABY_WIZARD'
		case BABY_HUNTER:
			return 'BABY_HUNTER'
		case BABY_PRIEST:
			return 'BABY_PRIEST'
		case BABY_BLACKSMITH:
			return 'BABY_BLACKSMITH'
		case BABY_ASSASSIN:
			return 'BABY_ASSASSIN'
		case BABY_STAR_GLADIATOR:
			return 'BABY_STAR_GLADIATOR'
		case BABY_REBELLION:
			return 'BABY_REBELLION'
		case BABY_KAGEROU:
			return 'BABY_KAGEROU'
		case BABY_OBORO:
			return 'BABY_OBORO'
		//Baby 2-2 Jobs
		case BABY_CRUSADER:
			return 'BABY_CRUSADER'
		case BABY_SAGE:
			return 'BABY_SAGE'
		case BABY_BARD:
			return 'BABY_BARD'
		case BABY_DANCER:
			return 'BABY_DANCER'
		case BABY_MONK:
			return 'BABY_MONK'
		case BABY_ALCHEMIST:
			return 'BABY_ALCHEMIST'
		case BABY_ROGUE:
			return 'BABY_ROGUE'
		case BABY_SOUL_LINKER:
			return 'BABY_SOUL_LINKER'
		//3-1 Jobs
		case SUPER_NOVICE_E:
			return 'SUPER_NOVICE_E'
		case RUNE_KNIGHT:
			return 'RUNE_KNIGHT'
		case WARLOCK:
			return 'WARLOCK'
		case RANGER:
			return 'RANGER'
		case ARCH_BISHOP:
			return 'ARCH_BISHOP'
		case MECHANIC:
			return 'MECHANIC'
		case GUILLOTINE_CROSS:
			return 'GUILLOTINE_CROSS'
		case STAR_EMPEROR:
			return 'STAR_EMPEROR'
		//3-2 Jobs
		case ROYAL_GUARD:
			return 'ROYAL_GUARD'
		case SORCERER:
			return 'SORCERER'
		case MINSTREL:
			return 'MINSTREL'
		case WANDERER:
			return 'WANDERER'
		case SURA:
			return 'SURA'
		case GENETIC:
			return 'GENETIC'
		case SHADOW_CHASER:
			return 'SHADOW_CHASER'
		case SOUL_REAPER:
			return 'SOUL_REAPER'
		//Trans 3-1 Jobs
		case RUNE_KNIGHT_T:
			return 'RUNE_KNIGHT_T'
		case WARLOCK_T:
			return 'WARLOCK_T'
		case RANGER_T:
			return 'RANGER_T'
		case ARCH_BISHOP_T:
			return 'ARCH_BISHOP_T'
		case MECHANIC_T:
			return 'MECHANIC_T'
		case GUILLOTINE_CROSS_T:
			return 'GUILLOTINE_CROSS_T'
		//Trans 3-2 Jobs
		case ROYAL_GUARD_T:
			return 'ROYAL_GUARD_T'
		case SORCERER_T:
			return 'SORCERER_T'
		case MINSTREL_T:
			return 'MINSTREL_T'
		case WANDERER_T:
			return 'WANDERER_T'
		case SURA_T:
			return 'SURA_T'
		case GENETIC_T:
			return 'GENETIC_T'
		case SHADOW_CHASER_T:
			return 'SHADOW_CHASER_T'
		//Baby 3-1 Jobs
		case SUPER_BABY_E:
			return 'SUPER_BABY_E'
		case BABY_RUNE_KNIGHT:
			return 'BABY_RUNE_KNIGHT'
		case BABY_WARLOCK:
			return 'BABY_WARLOCK'
		case BABY_RANGER:
			return 'BABY_RANGER'
		case BABY_ARCH_BISHOP:
			return 'BABY_ARCH_BISHOP'
		case BABY_MECHANIC:
			return 'BABY_MECHANIC'
		case BABY_GUILLOTINE_CROSS:
			return 'BABY_GUILLOTINE_CROSS'
		case BABY_STAR_EMPEROR:
			return 'BABY_STAR_EMPEROR'
		//Baby 3-2 Jobs
		case BABY_ROYAL_GUARD:
			return 'BABY_ROYAL_GUARD'
		case BABY_SORCERER:
			return 'BABY_SORCERER'
		case BABY_MINSTREL:
			return 'BABY_MINSTREL'
		case BABY_WANDERER:
			return 'BABY_WANDERER'
		case BABY_SURA:
			return 'BABY_SURA'
		case BABY_GENETIC:
			return 'BABY_GENETIC'
		case BABY_SHADOW_CHASER:
			return 'BABY_SHADOW_CHASER'
		case BABY_SOUL_REAPER:
			return 'BABY_SOUL_REAPER'
		//Doram Jobs
		case SUMMONER:
			return 'SUMMONER'
		// case SPIRIT_HANDLER:        return SPIRIT_HANDLER;
		//4-1 Jobs
		// case HYPER_NOVICE:          return HYPER_NOVICE;
		// case DRAGON_KNIGHT:         return DRAGON_KNIGHT;
		// case ARCH_MAGE:             return ARCH_MAGE;
		// case WINDHAWK:              return WINDHAWK;
		// case CARDINAL:              return CARDINAL;
		// case MEISTER:               return MEISTER;
		// case SHADOW_CROSS:          return SHADOW_CROSS;
		// case SKY_EMPEROR:           return SKY_EMPEROR;
		// case NIGHT_WATCH:           return NIGHT_WATCH;
		// case SHINKIRO:
		// case SHIRANUI:              return SHINKIRO_SHIRANUI;
		//4-2 Jobs
		// case IMPERIAL_GUARD:        return IMPERIAL_GUARD;
		// case ELEMENTAL_MASTER:      return ELEMENTAL_MASTER;
		// case INQUISITOR:            return INQUISITOR;
		// case TROUBADOUR:
		// case TROUVERE:              return TROUBADOURTROUVERE;
		// case BIOLO:                 return BIOLO;
		// case ABYSS_CHASER:          return ABYSS_CHASER;
		// case SOUL_ASCETIC:          return SOUL_ASCETIC;
		//Unknown
		default:
			return -1
	}
}

export function jobNameFormat(JobName, source) {
	const jobName = JobName.toLowerCase().split('_')
	let output = []
	let convertedJobName = ''

	jobName.map((word) =>
		output.push(word.charAt(0).toUpperCase() + word.slice(1)),
	)

	convertedJobName = output[0]
	if (output.length > 1) {
		for (let i = 1; i < output.length; i++) {
			convertedJobName += '_' + output[i]
		}
	}
	if (JobName === 'BARDDANCER') convertedJobName = 'BardDancer'
	return convertedJobName
}

export function getFormatedClassName(Job) {
	return jobNameFormat(getClassName(Job))
}

export function getFormatedBaseClassName(Job) {
	return jobNameFormat(
		getClassName(Job & ~EAJL_UPPER & ~EAJL_BABY & ~EAJL_THIRD),
	)
}

export function getFirstClassName(Job) {
	return getClassName(
		Job & ~EAJL_UPPER & ~EAJL_BABY & ~EAJL_THIRD & ~EAJL_2 & ~IS_MALE,
	)
}

export function getSecondClassName(Job) {
	return getClassName(Job & ~EAJL_UPPER & ~EAJL_BABY & ~EAJL_THIRD)
}

export function getSecondRebirthClassName(Job) {
	return getClassName(Job & ~EAJL_BABY & ~EAJL_THIRD)
}

export function getThirdClassName(Job) {
	return getClassName(Job & ~EAJL_UPPER & ~EAJL_BABY)
}

export function isRebirth(Job) {
	return Job & EAJL_UPPER ? true : false
}
export function isSecondJob(Job) {
	return Job & EAJL_2 ? true : false
}
export function isThirdJob(Job) {
	return Job & EAJL_THIRD ? true : false
}
